export default __webpack_public_path__ + "static/media/aboutbanner.61e13f21.webp";